import './App.css';

import { Home } from './components/Home';
import { Footer } from './components/Footer';
import ResponsiveAppBar from './components/NavBar';
import React from 'react';

function App() {
  return (
    <div>
      <ResponsiveAppBar />
      <Home />
      <Footer />
    </div>
  );
}

export default App;
